/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import {
  Typography,
  Breadcrumbs,
  Link,
  Tooltip
} from '@mui/material';
import ProjectLink from './ProjectLink';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import mikeSharedTheme from '../../styles/mikeSharedTheme';
import { IGetProjectPath } from '../../Models/IGetProject';

interface IProps {
  breadcrumpsContent: Array<IGetProjectPath>;
  onClickCallBack: () => void;
  onRootClickCallback: () => void;
  rootBreadcrumpsName?: string;
}
const mikeBreadcrumpsLastLabelStyle = 
  css`
    font-weight: bold;
    color: ${mikeSharedTheme.palette.text.primary};    
    max-width: 15vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  `;

const mikeBreadcrumpsLinkLabelStyle = 
  css`
    text-decoration: none;
    cursor: pointer;   
    color: ${mikeSharedTheme.palette.text.primary}; 
    &:hover: {
      color: ${mikeSharedTheme.palette.text.primary};
    };
      &:active: {
      color: ${mikeSharedTheme.palette.text.primary};
    };
      &:focus: {
      color: ${mikeSharedTheme.palette.text.primary};
    };
    max-width: 15vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  `;

/**
 * @name AppBreadcrumpsNav
 * @summary Renders a list of links. Meant to be used as breadcrumbs in the MikeTopbar.
 */
export const AppBreadcrumpsNav = (props: IProps) => {
  const {
    breadcrumpsContent,
    onClickCallBack,
    onRootClickCallback,
    rootBreadcrumpsName,
    ...rest
  } = props;
  
  const handleClick = () => {
    onClickCallBack();
  };

  const handleRootClick = (e: any) => {
    e.preventDefault();
    if (onRootClickCallback){
      onRootClickCallback();
    } 
  };

  return (
    <Breadcrumbs
      maxItems={5}
      separator={<NavigateNextIcon color="primary" fontSize="small" />}
      aria-label="mikebreadcrumb"
      {...rest}>
      {rootBreadcrumpsName && (
        <Tooltip title={rootBreadcrumpsName}>
          <Link css={mikeBreadcrumpsLinkLabelStyle} onClick={handleRootClick}>
            <Typography css={mikeBreadcrumpsLinkLabelStyle} variant="body2">
              {rootBreadcrumpsName}
            </Typography>
          </Link>
        </Tooltip>
      )}
      {breadcrumpsContent.map((breadcrump: IGetProjectPath, index: number) => {
        const root = index === 0;
        const last = index > 0 && index === breadcrumpsContent.length - 1;
        
        return root ? (
          <Tooltip key={index + '_' + breadcrump.name} title={breadcrump.name}>
            <Link css={mikeBreadcrumpsLinkLabelStyle} onClick={handleRootClick}>
              <Typography css={mikeBreadcrumpsLinkLabelStyle} variant="body2">
                {breadcrump.name}
              </Typography>
            </Link>
          </Tooltip>
        ) : (
          <Tooltip key={index + '_' + breadcrump.name} title={breadcrump.name}>
            <Typography
              key={index + '_' + breadcrump.name}
              variant="body2"
              css={
                last ? mikeBreadcrumpsLastLabelStyle : mikeBreadcrumpsLinkLabelStyle
              }>
              {last ? (
                breadcrump.name
              ) : (
                <ProjectLink
                  key={index}
                  to={breadcrump.id}
                  text={breadcrump.name}
                  onClickCallBack={handleClick}
                />
              )}
            </Typography>
          </Tooltip>
        );
      })}
    </Breadcrumbs>
  );
};

export default AppBreadcrumpsNav;
